import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6fc3f7eb = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _24fac519 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _4ea6d9c3 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _11616dac = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _5c788448 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _2f0621b6 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _24e52a5e = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _524365d8 = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _21f43064 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _1667dbc8 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _94d764b4 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _0d6e388a = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _8bdd25be = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _32cfd013 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _43e7eb2c = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _5dbd89d0 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _269cf4a8 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _754d7550 = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _63618cd0 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _d9ae0496 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _0af97980 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _c8966670 = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _da6a13ba = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _2a624bb4 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _114d29f7 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _cca9def4 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _50d6b448 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _783ae014 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _1ae6e08a = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _f6b888ba = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _8a20de00 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _e2696c34 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _5eeb30d1 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _fd09883e = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _1d18ccf2 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _6a2bdf28 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _47a93ced = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _30c91272 = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _17e9d9be = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _4a55a384 = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _6957d0e8 = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _03b89de2 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _677dfbee = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _fa2015a4 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _7dfd3ec6 = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _6f860a4e = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _3dc4978b = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _f200dd44 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _1646d954 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _6b810915 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _31dd7f67 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _39e0253d = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _e294653e = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _a374241c = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _78d8ceec = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _80dc80ac = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _22d8fa7e = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _173d3370 = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _1f778f20 = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _482633f5 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _d637d2f2 = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _1acdd4fc = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _b581148e = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _7dee16a4 = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _7c0f047a = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _1a3260af = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _29a95268 = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _1b70b0af = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _78a649cc = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _5a1ff0a8 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _543b0d14 = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _4dcd52e3 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _6cc135f4 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _58f954b2 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _d0f38790 = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _e8f401e0 = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _6ee844d6 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _ada245ec = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _9c171dde = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _dff38bd8 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _207bb484 = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _00374e06 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _9b8e8d4a = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _5f6ba9bc = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _0a4e5832 = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _4593c94d = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _718a6640 = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _dd03dbf2 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _6fc3f7eb,
    name: "404-error"
  }, {
    path: "/app",
    component: _24fac519,
    name: "app"
  }, {
    path: "/buy-sell-your-home",
    component: _4ea6d9c3,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _11616dac,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _5c788448,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _2f0621b6,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _24e52a5e,
    name: "comparables"
  }, {
    path: "/contact",
    component: _524365d8,
    name: "contact"
  }, {
    path: "/faq",
    component: _21f43064,
    name: "faq"
  }, {
    path: "/favourites",
    component: _1667dbc8,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _94d764b4,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _0d6e388a,
    name: "listing-management"
  }, {
    path: "/login",
    component: _8bdd25be,
    name: "login"
  }, {
    path: "/market-data",
    component: _32cfd013,
    name: "market-data"
  }, {
    path: "/messages",
    component: _43e7eb2c,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _5dbd89d0,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _269cf4a8,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _754d7550,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _63618cd0,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _d9ae0496,
    name: "offers"
  }, {
    path: "/privacy",
    component: _0af97980,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _c8966670,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _da6a13ba,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _2a624bb4,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _114d29f7,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _cca9def4,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _50d6b448,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _783ae014,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _1ae6e08a,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _f6b888ba,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _8a20de00,
    name: "users"
  }, {
    path: "/whoweare",
    component: _e2696c34,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _5eeb30d1,
    name: "why-bode"
  }, {
    path: "/admin/conversation",
    component: _fd09883e,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _1d18ccf2,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _6a2bdf28,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _47a93ced,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _30c91272,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _17e9d9be,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _4a55a384,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _6957d0e8,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _03b89de2,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _677dfbee,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _fa2015a4,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _7dfd3ec6,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _6f860a4e,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _3dc4978b,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _f200dd44,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _1646d954,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _6b810915,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _31dd7f67,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _39e0253d,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _e294653e,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _a374241c,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _78d8ceec,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _80dc80ac,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _22d8fa7e,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _173d3370,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _1f778f20,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _482633f5,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _d637d2f2,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _1acdd4fc,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _b581148e,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _7dee16a4,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _7c0f047a,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _1a3260af,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _29a95268,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _1b70b0af,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _78a649cc,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _5a1ff0a8,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _543b0d14,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _4dcd52e3,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _6cc135f4,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _58f954b2,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _d0f38790,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _e8f401e0,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _6ee844d6,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _ada245ec,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _9c171dde,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _dff38bd8,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _207bb484,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _00374e06,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _9b8e8d4a,
    name: "listings-id-submit-success"
  }, {
    path: "/settings/:section?/enums",
    component: _5f6ba9bc,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _0a4e5832,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _4593c94d,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _718a6640,
    name: "users-id-section"
  }, {
    path: "/",
    component: _dd03dbf2,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
